// extracted by mini-css-extract-plugin
export default {"upload":"upload__UcZ+d"};